<template>
    <div>
        <e-dialog
                dialogType="other"
                dialog-title="附件"
                :center-dialog-visible="labelVisible"
                popup-width="600px"
                @submitPopupData="handleClose"
                @resetPopupData="handleClose">
            <div class="attach-box" v-for="(item,fileIndex) in attachList" :key="fileIndex">
                <div class="attach-left">
                    <a target="_blank" :href="item.url">
                        <eui-tooltip-over :tooltipStyle="{ 'width': '540px' }" class="file-name" :content="item.name">
                            <span>{{item.name}}</span>
                        </eui-tooltip-over>
                    </a>
                    <div class="margin-t4">
                        <div class="label-item" v-if="item.tags">{{item.tags}}</div>
                    </div>
                </div>
            </div>
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';
export default {
  name: 'showFileDialog',
  components: {
    eDialog
  },
  props: {
    labelVisible: Boolean,
    attachList: Array
  },
  methods: {
    handleClose() {
      this.$emit('update:labelVisible', false);
    },
  },
};
</script>

<style scoped lang="scss">
.attach-box {
    width: 560px;
    height: 60px;
    padding: 6px 10px 10px 10px;
    background: linear-gradient(90deg, #F5F5F5 0%, rgba(245, 245, 245, 0.20) 100%);
    margin-bottom: 10px;

    .attach-left {
        .margin-t4 {
            margin-top: 4px;
        }

        .label-item {
            width: 64px;
            height: 20px;
            border: 1px solid #D9D9D9;
            margin-right: 6px;
            color: #666;
            text-align: center;
            font-size: 12px;
            cursor: pointer;
            background-color: #fff;

            &:hover {
                background-color: #e9f3ff;
                border-color: #2587FF;
                color: #2587FF;
            }
        }
    }

    .file-name {
        color: #0064C8;
        cursor: pointer;
        margin-top: 2px;
    }
}

::v-deep .el-dialog__body {
    padding: 20px;
}
</style>
